<script lang="ts" setup>
const props = defineProps<{ group: any[] }>()

const [model] = defineModel<string | void>({ required: true })

const modelSplit = reactive(props.group.map(() => ''))

const str = computed(() => modelSplit.filter(v => v).join(' '))

model.value?.split('').forEach((v, i) => {
  modelSplit[i] = v
})

watch(str, (v) => {
  model.value = v ? v : undefined
})

</script>

<template>
  <MRow class=" gap-4 w-full">
    <el-input class=" flex-1" v-for="(v, i) in group" v-model="modelSplit[i]" v-bind="v" />
  </MRow>
</template>

<style lang="scss" scoped></style>
